import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export default function useBack(to) {
  const history = useHistory();
  return useCallback(() => (to ? history.push(to) : history.goBack()), [history, to]);
}
